export enum DisparityType {
  PER_CAPITA = -1,
  TRANSITION = -2,
  SEVERITY = -3,
}
